// extracted by mini-css-extract-plugin
export default {"table":"style_table__yRSgw","dot":"style_dot__QTwlD","iconButton":"style_iconButton__do969","actionButton":"style_actionButton__whZ8N"};